import classNames from 'classnames';
import React from 'react';

export const Circle = ({ size = 20, showCheck = false }) => {
	const cls = classNames('common-steppers-circle', {
		checked: showCheck === true,
	});

	return (
		<div className={cls} style={{ width: size, height: size }}>
			<svg version="1.1" viewBox="0 0 330 330" width={size} height={size}>
				{showCheck === true ? (
					<>
						<circle fill="#fff" cx={165} cy={165} r={165} />
						<path
							d="M165,0C74.019,0,0,74.019,0,165s74.019,165,165,165s165-74.019,165-165S255.981,0,165,0z M165,300
					c-74.44,0-135-60.561-135-135S90.56,30,165,30s135,60.561,135,135S239.439,300,165,300z"
						/>
						<path
							d="M226.872,106.664l-84.854,84.853l-38.89-38.891c-5.857-5.857-15.355-5.858-21.213-0.001
		c-5.858,5.858-5.858,15.355,0,21.213l49.496,49.498c2.813,2.813,6.628,4.394,10.606,4.394c0.001,0,0,0,0.001,0
		c3.978,0,7.793-1.581,10.606-4.393l95.461-95.459c5.858-5.858,5.858-15.355,0-21.213
		C242.227,100.807,232.73,100.806,226.872,106.664z"
						/>
					</>
				) : (
					<circle cx={165} cy={165} r={165} />
				)}
			</svg>
		</div>
	);
};
